import { generateMedia } from "styled-media-query";
 
export const media = generateMedia({
    zero: "0px",
    small: "576px",
    medium: "980px",
    large: "1320px",
    huge: "1921px",
});